// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__2hsH9","title":"title__3CXH0","message":"message__eBz1M","link":"link__2kfDb"};